import axios from 'axios'
import { getShop } from '@helpers/env'
import { RecommendedProduct } from 'types/recommendations'
import { Fit } from 'types/fit'
import { CartState } from '@store/redux/reducers/cartReducer'

type ProductTypeOverride = {
  productType: string
  productCategory: string
}

type RecomendationsPayload = {
  cart: CartState
  overrides:
    | {
        trousers?: Record<string, ProductTypeOverride[]>
        denim?: Record<string, ProductTypeOverride[]>
        shorts?: Record<string, ProductTypeOverride[]>
        tops?: Record<string, ProductTypeOverride[]>
        accessories?: Record<string, ProductTypeOverride[]>
      }
    | undefined
  savedFit?: Partial<Fit>
  overrideRules?: {
    maxPerType?: number
    resultLimit?: number
  }
}

const SHOP = getShop()

export function getRecommendations(
  body: RecomendationsPayload
): Promise<RecommendedProduct[]> {
  const path = `${process.env.RECOMMENDATIONS_API_DOMAIN}/api/cart-recommendations/${SHOP}`
  return axios
    .post(path, body, {
      headers: {
        'x-api-key': process.env.RECOMMENDATIONS_API_KEY as string
      }
    })
    .then(({ data }: { data: RecommendedProduct[] }) => data)
}
